import React, { createContext, useContext, useRef, useState } from 'react';

const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [company, setCompany] = useState(null);
    const [username, setUsername] = useState(null);
    const [admin, setAdmin] = useState(false);
    const [activeSSHHost, setActiveSSHHost] = useState(null);

    return (
        <UserContext.Provider value={{ username, setUsername, admin, setAdmin, user, setUser, company, setCompany, activeSSHHost, setActiveSSHHost }}>
            {children}
        </UserContext.Provider>
    )
}